import(/* webpackMode: "eager", webpackExports: ["ClientSeoDescription"] */ "/app/src/components/SeoDescription/ClientSeoDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LobbyPage"] */ "/app/src/modules/lobby/index.tsx");
